<template>
  <div id="ContactUs">
    <div class="banner container-fuild text-center">联系我们</div>
    <div class="container">
      <div class="container-fuild ContactUs-container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-6">
            <form>
              <div class="row g-4">
                <div class="col-lg-12">
                  <div class="form-inner">
                    <input type="text" name="name" placeholder="你的名字" />
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-inner">
                    <input type="text" name="email" placeholder="你的邮箱" />
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-inner">
                    <input type="text" name="tel" placeholder="你的电话" />
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="form-inner">
                    <textarea
                      name="content"
                      cols="30"
                      rows="4"
                      placeholder="咨询的内容"
                    ></textarea>
                  </div>
                </div>
                <div class="col-lg-12 text-center mb-3">
                  <input type="submit" value="提交" class="eg-btn btn--submit" />
                </div>
              </div>
            </form>
          </div>
          <!-- <div class="col-xs-12 col-sm-12 col-md-6 mt-sm-3"> -->
          <div class="col-xs-12 col-sm-12 col-md-6">
            <div id="map" class="wow zoomIn"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import BMap from "BMap";
export default {
  name: "ContactUs",
  data() {
    return {};
  },
  mounted() {
    this.initBaiduMap(0);
    var wow = new WOW();
    wow.init();
  },
  methods: {
    // 百度地图 JS 为异步加载，BMap 可能尚未就绪；轮询等待就绪后再初始化，避免预渲染/弱网下崩溃
    initBaiduMap(attempt) {
      if (typeof BMap === "undefined") {
        if (attempt < 20) setTimeout(() => this.initBaiduMap(attempt + 1), 300);
        return;
      }
      var map = new BMap.Map("map"); // 创建地图实例
      var point = new BMap.Point(110.332133, 20.03529); // 创建点坐标
      map.centerAndZoom(point, 18); // 初始化地图，设置中心点坐标和地图级别
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var opts = {
        width: 50, // 信息窗口宽度
        height: 10, // 信息窗口高度
        title: "海南华德科技有限公司", // 信息窗口标题
      };
      var infoWindow = new BMap.InfoWindow("瑞特广场23楼", opts); // 创建信息窗口对象
      map.openInfoWindow(infoWindow, map.getCenter()); // 打开信息窗口
    },
  },
};
</script>
<style scoped>
@import url("../assets/css/style.css");
.banner {
  color: #fff;
  font-size: 30px;
  height: 150px;
  line-height: 150px;
  /* 与首页 .banner-section1 同款 6 层叠加（点阵→玫红径向→紫径向→横向暗遮罩→纵向压暗→摄影底图）
     内页 banner 高度仅 150px，径向光圈中心点上下调到 50%（避免靠上下边缘溢出）；
     横向遮罩仍左强右弱，文字居中显示。
     底图取首页同一张 banner-photo.jpg，统一暗色科技夜景基调。 */
  background-color: #05070f;
  background-image:
    url("../assets/images/bg/brand-pattern.svg"),
    radial-gradient(circle at 80% 50%, rgba(230, 0, 76, 0.38), rgba(230, 0, 76, 0) 42%),
    radial-gradient(circle at 20% 50%, rgba(120, 20, 90, 0.30), rgba(120, 20, 90, 0) 45%),
    linear-gradient(102deg, rgba(4, 6, 16, 0.82) 0%, rgba(4, 6, 16, 0.70) 30%, rgba(6, 9, 22, 0.47) 56%, rgba(9, 13, 28, 0.28) 78%, rgba(9, 13, 28, 0.44) 100%),
    linear-gradient(180deg, rgba(4, 6, 16, 0.55) 0%, rgba(4, 6, 16, 0) 32%, rgba(4, 6, 16, 0) 66%, rgba(4, 6, 16, 0.52) 100%),
    url("../assets/images/bg/banner-photo.jpg");
  background-position: center, center, center, center, center, 50% center;
  background-size: 40px 40px, cover, cover, cover, cover, cover;
  background-repeat: repeat, no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
}
.ContactUs-container {
  padding: 80px 0;
  transition: all ease 0.5s;
  box-sizing: border-box;
}
#map {
  width: 100%;
  height: 365px;
}
.row {
  margin-right: 0;
  margin-left: 0;
}
@media screen and (max-width: 997px) {
  .ContactUs-container {
    padding: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ContactUs.vue